export const QUICK_REACTION_EMOJIS = ["👍", "❤️", "😂", "😮", "😢", "🙏"] as const;

export type QuickReactionEmoji = (typeof QUICK_REACTION_EMOJIS)[number];

export function aggregateReactions(
  reactions: Array<{ emoji: string; userId: string }> | undefined,
  currentUserId: string | null,
): Array<{ emoji: string; count: number; userIds: string[]; reactedByMe: boolean }> {
  if (!reactions?.length) return [];
  const byEmoji = new Map<
    string,
    { emoji: string; count: number; userIds: string[]; reactedByMe: boolean }
  >();
  for (const row of reactions) {
    const entry = byEmoji.get(row.emoji) ?? {
      emoji: row.emoji,
      count: 0,
      userIds: [],
      reactedByMe: false,
    };
    entry.count += 1;
    entry.userIds.push(row.userId);
    if (currentUserId && row.userId === currentUserId) entry.reactedByMe = true;
    byEmoji.set(row.emoji, entry);
  }
  return Array.from(byEmoji.values());
}
